import { commonComponents as cc } from "@/components/common";
import { getDiaryById } from "@/features/diaries/api";
import { entryComponents as ec } from "@/features/entries/components";
import { extractObservationEntry } from "@/features/entries/hooks/useExtractEntry";
import { Link, createFileRoute } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { Button } from "../../../../../../../../components/ui/button";

export const Route = createFileRoute(
	"/_app/diaries/$diaryId/observation/$observationId/entry/$entryId/",
)({
	component: EditEntry,
	loader: async ({ params }) => {
		const { diaryId } = params;
		// Load the diary data - this will trigger the RouterSpinner
		await getDiaryById(diaryId);
		return { success: true };
	},
});

function EditEntry() {
	const { diaryId, observationId, entryId } = Route.useParams();
	const entry = extractObservationEntry(diaryId, observationId, entryId);

	return (
		<div className="space-y-4">
			<cc.Title words="Entry" />
			<ec.EditObservationEntry entry={entry} />
			<Button variant="secondary">
				<ArrowLeft size={24} />
				<Link to="/diaries/$diaryId/home/history">Back to Diary</Link>
			</Button>
			<ec.DeleteEntryButton diaryId={diaryId} entryId={entryId} />
		</div>
	);
}
